<template>
    <div>
        <div class="back_bg" v-if="state.isNavOpen" @click="selectMenu(state.selectMenu)"
            v-bind:style="{ display: state.isNavOpen ? 'block' : 'none' }"></div>
        <div class="side_menu_layer" :class="{ open: state.isNavOpen }">
            <div class="side_user_box">
                <p>
                    <span>{{ state.userInfo?.name }}</span> 님
                </p>
                <div class="side_user_links">
                    <router-link to="/mypage" @click="selectMenu('mypage')"><img src="@/assets/common/mypg_link_ico.png"
                            alt="" />마이페이지</router-link>
                    <router-link to="#" @click="logout"><img src="@/assets/common/logout_ico.png"
                            alt="" />로그아웃</router-link>
                </div>
            </div>
            <div class="side_menu">
                <ul>
                    <li :class="state.selectMenu == 'stress' ? 'active' : null">
                        <router-link to="/stressCare/category" @click="selectMenu('stress')">
                            <span>
                                <img src="@/assets/common/menu_ico2_off.png" alt="" class="off" />
                                <img src="@/assets/common/menu_ico2_on.png" alt="" class="on" />
                            </span>
                            <span>스트레스 케어</span>
                        </router-link>
                    </li>
                    <li :class="state.selectMenu == 'community' ? 'active' : null">
                        <router-link to="/community/list" @click="selectMenu('community')">
                            <span>
                                <img src="@/assets/common/menu_ico3_off.png" alt="" class="off" />
                                <img src="@/assets/common/menu_ico3_on.png" alt="" class="on" />
                            </span>
                            <span>커뮤니티</span>
                        </router-link>
                    </li>
                    <li :class="state.selectMenu == 'youtube' ? 'active' : null">
                        <router-link to="/youtube/list" @click="selectMenu('youtube')">
                            <span>
                                <img src="@/assets/common/menu_ico4_off.png" alt="" class="off" />
                                <img src="@/assets/common/menu_ico4_on.png" alt="" class="on" />
                            </span>
                            <span>경찰청 YOUTUBE</span>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="side_bottom">
                <button type="button" class="side_menu_close" @click="selectMenu(null)">
                    <img src="@/assets/common/menu_close_ico.png" />
                </button>
            </div>
        </div>
    </div>
    <Modal :show="state.isModalOpen" :content="modal.content" :yes="modal.confirm" :no="modal.cancel"
        @close="modalClose">
    </Modal>
</template>

<script lang="ts">
import { useRouter } from "vue-router";
import { userStore, globalStore, UserInfo, reactive, onMounted, watch } from "@/BaseComponent";
import Modal from "@/components/modal.vue";
export default {
    components: {
        Modal,
    },
    setup() {
        const router = useRouter();
        const global = globalStore();
        const user = userStore();

        const state = reactive({
            userInfo: {} as UserInfo | null,
            selectMenu: "" as string | null,
            isNavOpen: false,
            isModalOpen: false,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });

        const selectMenu = (menu: string | null) => {
            state.isNavOpen = false;
            global.setNavOpen(state.isNavOpen);
            if (menu != null) {
                global.setSelectMenu(menu);
                state.selectMenu = menu;
            }
        };

        const logout = () => {
            global.isNavOpen = false;
            modal.content = "로그아웃 하시겠습니까?";
            modal.confirm = "확인";
            modal.cancel = "취소";
            state.isModalOpen = true;
        };

        onMounted(() => {
            state.isNavOpen = global.isNavOpen;
            state.selectMenu = global.selectMenu;
            state.userInfo = user.userInfo as UserInfo;
        });

        watch(global, () => {
            state.isNavOpen = global.isNavOpen;
            state.selectMenu = global.selectMenu;
            if (global.isNavOpen) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
            state.userInfo = user.userInfo as UserInfo;
        });

        const modalClose = (result: any) => {
            if (result === true) {
                user.setToken(null);
                user.setInfo(null);
                global.setSelectMenu("");
                global.setChart("");
                router.push("/login");
            }
            state.isModalOpen = false;
        };

        return {
            state,
            modal,
            selectMenu,
            logout,
            modalClose,
        };
    },
};
</script>
<style scoped>
.side_menu_layer {
    position: fixed;
    left: -60%;
    transition: left 0.3s;
    z-index: 20;
}

.side_menu_layer.open {
    left: 0;
}
</style>
